var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHourglass = function SvgHourglass(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 8,
    "data-width-24": 12,
    viewBox: "0 0 7.8 13",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.09 6.509.667 4.447A1.82 1.82 0 0 1 0 3.053V1.5A1.5 1.5 0 0 1 1.52 0h4.667a1.5 1.5 0 0 1 1.5 1.5v1.553a1.82 1.82 0 0 1-.667 1.394l-2.387 2.03 2.44 2.076a1.82 1.82 0 0 1 .667 1.394V11.5A1.5 1.5 0 0 1 6.187 13H1.52a1.5 1.5 0 0 1-1.5-1.5V9.947a1.82 1.82 0 0 1 .667-1.394zm-1.922-5.36A.5.5 0 0 1 1.52 1h4.667a.507.507 0 0 1 .5.5v1.507a.84.84 0 0 1-.294.666l-2.54 2.16-2.54-2.113a.84.84 0 0 1-.293-.667V1.5a.5.5 0 0 1 .148-.352m.145 8.164 2.54-2.146 2.54 2.113a.84.84 0 0 1 .294.667V11.5a.507.507 0 0 1-.5.5H1.52a.506.506 0 0 1-.5-.5V9.98a.84.84 0 0 1 .293-.667",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHourglass);
export default ForwardRef;